/* eslint-disable import/no-anonymous-default-export */
export default (newInsurance = [], action) => {
  switch (action.type) {
    case "GET_ALL_UNAPPROVED_INSURANCE":
      return action.payload;
    case "APPROVE_NEW_INSURANCE":
      return newInsurance.filter((data) => data._id !== action.payload);
    case "DELETE_NEW_INSURANCE":
      return newInsurance.filter((data) => data._id !== action.payload);

    default:
      return newInsurance;
  }
};
